import classNames from 'classnames';
import CardBenefits, {
  Props as CardBenefitsProps
} from '../../Molecules/CardBenefits';
import Image from '../../Atoms/Image';

interface Props {
  leftSide?: CardBenefitsProps[];
  rightSide?: CardBenefitsProps[];
  image: string;
  className?: string;
}

function BlockImageCenter({
  leftSide,
  rightSide,
  image,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'grid grid-cols-1 gap-7 pt-10 md:grid-cols-3 md:pt-20',
        className
      ])}
    >
      <div className="grid gap-12">
        {leftSide?.map((item) => (
          <CardBenefits
            key={leftSide?.indexOf(item)}
            title={item.title}
            text={item.text}
            icon={item.icon}
          />
        ))}
      </div>

      <div className="grid items-center justify-center gap-12">
        <Image src={image} alt="description" />
      </div>

      <div className="grid gap-7 md:gap-12">
        {rightSide?.map((item) => (
          <CardBenefits
            key={rightSide?.indexOf(item)}
            title={item.title}
            text={item.text}
            icon={item.icon}
          />
        ))}
      </div>
    </div>
  );
}

export default BlockImageCenter;
